/** @jsx jsx */
import React from 'react';
import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { ViewSettingsPanelBase } from './ViewSettingsPanelBase.tsx';

const styles = cssMap({
	skeleton: {
		height: '20px',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('border.radius'),
	},
	header: {
		width: '60%',
	},
	row1: {
		width: '100%',
	},
	row2: {
		width: '80%',
	},
	row3: {
		width: '90%',
	},
	row4: {
		width: '70%',
	},
});

type Props = {
	onClose: () => void;
};

export const ViewSettingsPanelFallback = ({ onClose }: Props) => {
	return (
		<ViewSettingsPanelBase
			header={<div css={[styles.skeleton, styles.header]} />}
			onClose={onClose}
		>
			<div css={[styles.skeleton, styles.row1]} />
			<div css={[styles.skeleton, styles.row2]} />
			<div css={[styles.skeleton, styles.row3]} />
			<div css={[styles.skeleton, styles.row4]} />
		</ViewSettingsPanelBase>
	);
};
